import { render } from "./VotesTableCategories.vue?vue&type=template&id=1a4c529a"
import script from "./VotesTableCategories.vue?vue&type=script&lang=js"
export * from "./VotesTableCategories.vue?vue&type=script&lang=js"

import "./VotesTableCategories.vue?vue&type=style&index=0&id=1a4c529a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__